import comp, { USER_TYPE_IDS, HOME_PATH_BY_USER_TYPE } from './UserTypeGate';

export default comp;

export { USER_TYPE_IDS, HOME_PATH_BY_USER_TYPE };
